export const enum BetOfferType {
  Handicap = 1,
  '1x2' = 2,
  Result = 3,
  Outright = 4,
  OverUnder = 6,
  AsianHandicap = 7,
  HalfTimeFullTime = 8,
  SideBet = 9,
  OddEven = 10,
  ThreeWayHCP = 11,
  DoubleChance = 12,
  HeadToHead = 13,
  Scorer = 17,
  YesNo = 18,
  MultiPosition = 19,
  AsianOverUnder = 21,
  Position = 117,
  WinningMargin = 124,
  PlayerOccurrenceNumber = 125,
  PlayerLastOccurrence = 126,
  PlayerOccurrenceLine = 127,
  OccurrenceMethod = 128,
}

export const enum PushMessageTypeId {
  /** This message is sent when outcome odds are changed within an event It can be one single or more outcomes */
  BetOfferOddsUpdated = 11,
  /** This message is sent when data in the match clock is is stopped, started or enabled If the match clock has 'running'=true, the consumer is responsible for ticking up the clock (or down if showing reverse time) each second until the match clock is updated or event is removed. */
  MatchClockUpdated = 15,
  /** This message is sent when current score is updated for an in-play event */
  EventScoreUpdated = 16,
  /** This message is sent when statistics is updated for an in-play event */
  EventStatsUpdated = 17,
}
